import styles from './IconDefault.module.scss';

export function IconChecklist() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.0714 4C14.377 4 14.1327 4 14.0467 4.11669C14 4.18003 14 4.27777 14 4.42857C14 6.14286 15.0714 7 16.1429 7H26.8571C27.9286 7 29 6.14286 29 4.42857C29 4.27771 29 4.17995 28.9533 4.11661C28.8675 4.00012 28.6237 4 27.9318 4H33C34.6569 4 36 5.34315 36 7V13V35C36 36.6569 34.6569 38 33 38H10C8.34315 38 7 36.6569 7 35V7C7 5.34315 8.34315 4 10 4H15.0714ZM19 14C18.4477 14 18 14.4477 18 15C18 15.5523 18.4477 16 19 16H29C29.5523 16 30 15.5523 30 15C30 14.4477 29.5523 14 29 14H19ZM18 22C18 21.4477 18.4477 21 19 21H29C29.5523 21 30 21.4477 30 22C30 22.5523 29.5523 23 29 23H19C18.4477 23 18 22.5523 18 22ZM19 28C18.4477 28 18 28.4477 18 29C18 29.5523 18.4477 30 19 30H29C29.5523 30 30 29.5523 30 29C30 28.4477 29.5523 28 29 28H19Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.7474 12.3356C17.1143 12.7484 17.0772 13.3805 16.6644 13.7474L11.5 18.338L9.33565 16.4141C8.92286 16.0472 8.88568 15.4151 9.2526 15.0023C9.61952 14.5895 10.2516 14.5524 10.6644 14.9193L11.5 15.6621L15.3356 12.2526C15.7484 11.8857 16.3805 11.9229 16.7474 12.3356Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.9984 1.86658C25.9984 1.86653 25.9985 1.86746 25.9986 1.86945L25.9984 1.86658ZM25.975 2.5C25.8382 3.78652 25.1789 4 25 4H15C14.8211 4 14.1618 3.78652 14.025 2.5H25.975ZM14.0016 1.86665C14.0016 1.86668 14.0016 1.8676 14.0014 1.86932L14.0016 1.86665ZM27.7305 1C27.612 0.84854 27.468 0.740866 27.3221 0.667953C27.0579 0.535885 26.7779 0.517337 26.6335 0.509326C26.4649 0.499975 26.2538 0.499987 26.0262 0.500001H13.9745C13.7465 0.499988 13.5352 0.499976 13.3664 0.509354C13.2219 0.517382 12.942 0.535971 12.6778 0.668075C12.532 0.740983 12.388 0.848622 12.2696 1H8C5.79086 1 4 2.79086 4 5V22C4 22.5523 4.44772 23 5 23C5.55228 23 6 22.5523 6 22V5C6 3.89543 6.89543 3 8 3H12.0824C12.3818 4.75713 13.4758 6 15 6H25C26.5242 6 27.6182 4.75713 27.9176 3H31C32.1046 3 33 3.89543 33 5V33C33 34.1046 32.1046 35 31 35H8C6.89543 35 6 34.1046 6 33V32C6 31.4477 5.55228 31 5 31C4.44772 31 4 31.4477 4 32V33C4 35.2091 5.79086 37 8 37H31C33.2091 37 35 35.2091 35 33V5C35 2.79086 33.2091 1 31 1H27.7305Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M6 25.1875C6 25.7398 5.55228 26.1875 5 26.1875C4.44772 26.1875 4 25.7398 4 25.1875C4 24.6352 4.44772 24.1875 5 24.1875C5.55228 24.1875 6 24.6352 6 25.1875Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M6 28.5C6 29.0523 5.55228 29.5 5 29.5C4.44772 29.5 4 29.0523 4 28.5C4 27.9477 4.44772 27.5 5 27.5C5.55228 27.5 6 27.9477 6 28.5Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
		</svg>
	);
}
